/**
 * DTemplate Demos
 * The deck's live products: the homepage's demos and Kids Clothes, each
 * with the frame a still phone shows
 */

import { LIVE_DEMOS, type LiveDemo } from '@components/press/pitch-deck/slides/demo-phone';

/*
 * June, 2026-10-07: "Improve the screenshots the save gets frozen on." A
 * still phone (the export, reduced motion) showed its recording's first
 * frame, from before the answer: an unscrolled plan, an empty growth
 * chart. These frames come from later in the same 2x recordings, with
 * the answer on screen: the Saturday's first stop and what's on there
 * (2.5 s), the family's heights and percentiles (16.8 s), and the
 * commute's cheat sheet (62.6 s).
 */
const STILLS: Readonly<Record<string, string>> = {
  adventures: '/videos/demo/adventures-still.jpg',
  growth: '/videos/demo/growth-curves-still.jpg',
  commute: '/videos/demo/commute-still.jpg',
};

export type DeckDemo = LiveDemo & { still?: string };

/*
 * Kids Clothes, live (June, 2026-10-07: "Kids clothing is live, ask the
 * simulator agent for a temporary local link to its demo"), isn't on the
 * homepage yet, so the deck carries it. Its recording is the Simulators
 * agent's of 2026-10-07 (iPhone 17 simulator, the app at 1.7.0), opening
 * on a saved report's story; June chose it for the deck as it is. Here at
 * the homepage demos' 2x, 540x1174, 30 fps; its still is the settled
 * summary. The wish is the app's own words on its Explore tile; what went
 * in is the product's as built (data-clothing: size charts for over 100
 * brands, the kidfit growth and fit models, no LLM in the request path).
 */
const KIDS_CLOTHES: DeckDemo = {
  key: 'kids-clothes',
  wish: 'What size is it at each store?',
  title: 'Kids Clothes',
  screen: {
    video: '/videos/demo/kids-clothes-2x.mp4',
    poster: '/videos/demo/kids-clothes.jpg',
    label: 'The app sizing a child across brands: his estimated sizes, each brand’s fit and prices, then the sales on now.',
  },
  built: {
    data: 'Size Charts for 100+ Brands, Prices and Daily Sales',
    expert: 'Growth Projections, Brand Fit and Foot-Length Models',
    skills: 'Sizes at Every Brand, Sales and Reports Saved per Child',
  },
  still: '/videos/demo/kids-clothes-still.jpg',
};

/** The live demos, in the homepage's order, with their stills, then Kids
 *  Clothes. */
export const DECK_DEMOS: readonly DeckDemo[] = [
  ...LIVE_DEMOS.map((demo) => ({ ...demo, still: STILLS[demo.key] })),
  KIDS_CLOTHES,
];
